<script setup>
import { ref, onBeforeUnmount } from 'vue';

const { position, largeurIni } = defineProps({
  position: String,
  largeurIni: Number
});

const largeur = ref(largeurIni);
const redimensionnementEnCours = ref(false);

const commencerRedimensionnement = () => {
  redimensionnementEnCours.value = true;
  document.body.classList.add('sans-selection');
  document.addEventListener('mousemove', gererRedimensionnement);
  document.addEventListener('mouseup', stopperRedimensionnement);
};

const gererRedimensionnement = (e) => {
  if (!redimensionnementEnCours.value) {
    return;
  }
  const screenWidth = window.innerWidth;

  if (position === 'gauche') {
    const nouvelleLargeur = e.clientX;
    if (nouvelleLargeur >= 0 && nouvelleLargeur <= window.innerWidth / 2) {
      largeur.value = nouvelleLargeur;
    }
  } else {
    const nouvelleLargeur = screenWidth - e.clientX;
    if (nouvelleLargeur >= 0 && nouvelleLargeur <= window.innerWidth / 2) {
      largeur.value = nouvelleLargeur;
    }
  }
}

const stopperRedimensionnement = () => {
  redimensionnementEnCours.value = false;
  document.removeEventListener('mousemove', gererRedimensionnement);
  document.removeEventListener('mouseup', stopperRedimensionnement);
  document.body.classList.remove('sans-selection');
}

// Cleanup au démontage
onBeforeUnmount(() => {
  stopperRedimensionnement();
});

</script>

<template>
  <div
    class="panel-redimensionnable"
    :style="{ width: largeur + 'px' }"
    ref="panel"
  >
    <!-- Poignée de redimension -->
    <div
      class="poignee"
      :class="position === 'gauche' ? 'poignee-droite' : 'poignee-gauche'"
      @mousedown="commencerRedimensionnement">
      <i class="icone fa fa-arrows-left-right" />
    </div>

    <!-- Slot pour contenu -->
    <div class="contenu-panel">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>

.panel-redimensionnable {
  position: relative;
  min-width: 100px;
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
}

.contenu-panel {
  flex-grow: 1;
}

.poignee {
  position: absolute;
  width: 20px;
  bottom: -6px;
  height: 20px;  
  z-index: 10;
  cursor: ew-resize;
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: var(--couleur-bordure);
  background-color: white;
}

.poignee-gauche {
  left: 2px;
}

.poignee-droite {
  right: -2px;
}

.contenu-panel {
	height: 100%;
  width: 100%;
}

.contenu-panel .p-tabview.p-component {
	height: 100%;
  width: 100%;
}

.contenu-panel .p-tabview-panels {
	height: 100%;
  width: 100%;
	overflow: auto;
}

</style>
